import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c642543c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c642543c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642543c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c642543c')) {
      api.createRecord('c642543c', component.options)
    } else {
      api.reload('c642543c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c642543c&scoped=true&", function () {
      api.rerender('c642543c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VutC123rHWFy/JS/comp/PopupBox.vue"
export default component.exports